<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-cube', fontSet: 'fad'}"
	[headerText]="T.SCENARIO_INFORMATION_DIALOG_TITLE | translate: {name: data?.scenario?.name ?? ''}"
	[matDialogData]="data"
	[overflowHandledByChild]="true"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<mat-tab-group style="flex: 1; overflow: hidden" color="accent">
			<mat-tab label="Scenario Description">
				{{ data?.scenario?.description }}
			</mat-tab>

			@if (data.trainingSession) {
				<mat-tab label="Operator Checklists">
					@if (checklists.length > 0) {
						<mat-tab-group [dynamicHeight]="true" class="innerTabs h-100">
							@for (checklist of checklists; track checklist) {
								<mat-tab [label]="checklist.name">
									<sim-operator-checklist-panel [assessable]="checklist" [mode]="AssessablePanelMode.Answer" />
								</mat-tab>
							}
						</mat-tab-group>
					}
					@if (checklists.length <= 0) {
						<p>{{ T.SCENARIO_INFORMATION_DIALOG_NO_OPERATOR_CHECKLISTS | translate }}</p>
					}
				</mat-tab>
			}

			@if (data.trainingSession) {
				<mat-tab label="Technical Requirement">
					<h2 class="mat-h2">{{ T.SCENARIO_DESIGNER_TEXT_TECHNICAL_REQUIREMENTS_ROOM_VISION | translate }}</h2>
					<div class="checklistGroup">
						<h3 class="mat-h3 nomargin"></h3>
						<div class="options">
							<p class="checklistOption">
								<mat-checkbox [checked]="data.scenario.technicalReqRoomVision.patient?.mannequin" color="accent" disabled>
									{{ T.SCENARIO_DESIGNER_TEXT_MANIKIN | translate }}
								</mat-checkbox>
							</p>
							<p class="checklistOption">
								<mat-checkbox [checked]="data.scenario.technicalReqRoomVision.patient?.sp" color="accent" disabled
									>{{ T.SCENARIO_DESIGNER_TEXT_SP_CHECK_LABEL | translate }}
								</mat-checkbox>
							</p>
							<p class="checklistOption">
								<mat-checkbox [checked]="data.scenario.technicalReqRoomVision.patient?.taskTrainer" color="accent" disabled
									>{{ T.SCENARIO_DESIGNER_TEXT_TASK_TRAINER_CHECK | translate }}
								</mat-checkbox>
							</p>
							<p class="checklistOption">
								<mat-checkbox [checked]="data.scenario.technicalReqRoomVision.patient?.hybrid" color="accent" disabled>
									{{ T.SCENARIO_DESIGNER_TEXT_HYBRID_CHECK | translate }}
								</mat-checkbox>
							</p>
						</div>
					</div>
					<mat-divider style="margin-bottom: 20px" />
					<mat-form-field class="full-width-form" color="accent">
						<mat-label>{{ T.SCENARIO_DESIGNER_TEXT_SPECIAL_EQUIPMENT_REQ_LABEL | translate }}</mat-label>
						<textarea
							[cdkAutosizeMaxRows]="5"
							[value]="data.scenario.technicalReqRoomVision.specialEquipment"
							[cdkTextareaAutosize]="true"
							disabled
							matInput
							placeholder="..."
							rows="2"
						></textarea>
					</mat-form-field>
					<mat-form-field class="full-width-form" color="accent">
						<mat-label>{{ T.SCENARIO_DESIGNER_TEXT_REQUIRED_MEDICATIONS | translate }}</mat-label>
						<textarea
							[cdkAutosizeMaxRows]="5"
							[value]="data.scenario.technicalReqRoomVision.requiredMedications"
							[cdkTextareaAutosize]="true"
							disabled
							matInput
							placeholder="..."
							rows="2"
						></textarea>
					</mat-form-field>
					<mat-form-field class="full-width-form" color="accent">
						<mat-label>{{ T.SCENARIO_DESIGNER_TEXT_Moulage | translate }}</mat-label>
						<textarea
							[cdkAutosizeMaxRows]="5"
							[value]="data.scenario.technicalReqRoomVision.moulage"
							[cdkTextareaAutosize]="true"
							disabled
							matInput
							placeholder="..."
							rows="2"
						></textarea>
					</mat-form-field>
					<div class="checklistGroup">
						<h3 class="mat-h3 nomargin">{{ T.SCENARIO_DESIGNER_TEXT_MONITORS_AT_CASE_ONSET | translate }}</h3>
						<div class="options">
							<p class="checklistOption">
								<mat-checkbox
									[checked]="data.scenario.technicalReqRoomVision.monitorsAtCase?.monitorWithVitals"
									color="accent"
									disabled
								>
									{{ T.SCENARIO_DESIGNER_TEXT_PATIENT_ON_MONITOR_WITH_VITALS | translate }}
								</mat-checkbox>
							</p>
							<p class="checklistOption">
								<mat-checkbox
									[checked]="data.scenario.technicalReqRoomVision.monitorsAtCase?.monitorWithOutVitals"
									color="accent"
									disabled
									>{{ T.SCENARIO_DESIGNER_TEXT_PATIENT_NOT_MONITOR | translate }}
								</mat-checkbox>
							</p>
						</div>
					</div>
					<mat-divider style="margin-bottom: 20px" />
					<mat-form-field class="full-width-form" color="accent">
						<mat-label>{{ T.SCENARIO_DESIGNER_TEXT_PATIENT_REACTION_AND_EXAM | translate }}</mat-label>
						<textarea
							[cdkAutosizeMaxRows]="5"
							[value]="data.scenario.technicalReqRoomVision.patientReactionsExams"
							[cdkTextareaAutosize]="true"
							disabled
							matInput
							placeholder="..."
							rows="2"
						></textarea>
					</mat-form-field>
				</mat-tab>
			}
		</mat-tab-group>
	</ng-container>

	<ng-container actions>
		@if (permissionScenarioAccessAll) {
			<button (click)="openInAdmin()" color="accent" mat-raised-button style="margin-right: 15px">
				{{ T.SCENARIO_INFORMATION_DIALOG_OPEN_BUTTON | translate }}
			</button>
		}

		<button (click)="close({action: 'close'})" color="warn" mat-raised-button>
			{{ T.SCENARIO_INFORMATION_DIALOG_CLOSE_BUTTON | translate }}
		</button>
	</ng-container>
</sim-basic-material-dialog>
